import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import LogisticsMonitoringContainer from '../../containers/logistics/Monitoring';
import DeliveriesContainer from '../../containers/logistics/StationDeliveries';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import DeliveryEstimateDialog from '../../components/Dialogs/DeliveryEstimateDialog';

import { valueToDisplay } from '../../libs/products';
import { getLegs as getDeliveryLegs } from '../../libs/deliveryLegs';

import {
	//	doesStationMatchFilter,
	formatDeliveryWindow,
	sortStationTable,
	formatStatus,
	statusClassNames,
	isFiltered,
	PureRecordRow,
} from '../../libs/utility';

//- material-ui
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
//import TableRow from '@material-ui/core/TableRow';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';

import TruckIcon from '@material-ui/icons/LocalShipping';
import EyeIcon from '@material-ui/icons/Visibility';
import InactiveIcon from '@material-ui/icons/NotInterested';
import FlagIcon from '@material-ui/icons/Flag';

import Popover from '@material-ui/core/Popover';
//import { Link } from 'react-router-dom';

import { getSharedStyles } from '../../themes';
import InitialLoading from '../../components/InitialLoading';
import FMPStationRegionMultiPicker from '../../components/pureForm/FMPStationRegionMultiPicker';
import FormComponent from '../../components/FormComponent';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';

// NOTE REMEMBER TO ADD THEM TO THE BACKEND AS WELL
// Just search for STATIONS_TO_HIDE
const R043_ID = 109; // R043
const R212_ID = 619; // R212
const R302_ID = 754; //  station is not cooperating with providing inventory
const STATIONS_TO_HIDE = [R043_ID, R212_ID, R302_ID];

const styles = (theme) => ({
	...getSharedStyles(theme),
	...statusClassNames,
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	tankOuter: {
		backgroundColor: '#5C5C5C',
		borderRadius: 200,
		width: 50,
		height: 50,
		overflow: 'hidden',
		position: 'relative',
		border: '2px solid #97979A',
		marginRight: 10,
	},
	tankInner: {
		position: 'absolute',
		width: '100%',
		bottom: 0,
	},
	tankContainer: {
		display: 'flex',
	},
	tankInfo: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	errorRow: {
		backgroundColor: '#FECDD1',
		//backgroundColor : '#FFECF0',
	},
	rowButton: {
		textAlign: 'left',
		textTransform: 'none',
		fontWeight: 400,
		fontSize: 13,
		lineHeight: 1.5,
		padding: `3px 8px`,
	},
	table: {
		width: '100%',
		tableLayout: 'auto',
	},
	freshnessColor: {
		height: 12,
		width: 12,
		border: `.5px solid #555`,
		borderRadius: 2,
		display: 'inline-block',
		marginRight: 5,
	},
	warningFlag: {
		color: '#FFC107',
		width: 16,
		height: 16,
		paddingRight: 3,
	},
	errorFlag: {
		color: '#e53935',
		width: 20,
		height: 20,
		paddingRight: 3,
	},
	popover: {
		pointerEvents: 'none',
	},
	commentsContainer: {
		padding: 7,
		display: 'inline-block',
		fontSize: '90%',
		maxWidth: '400px',
	},
	commentDateTime: {
		fontSize: '80%',
		color: '#666',
	},
});

/**
 * Converts an HSL color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes h, s, and l are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param   {Number}  h       The hue
 * @param   {Number}  s       The saturation
 * @param   {Number}  l       The lightness
 * @return  Array           The RGB representation
 */
function hslToRgb(h, s, l) {
	let r, g, b;

	if (s === 0) {
		r = g = b = l; // achromatic
	} else {
		let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
		let p = 2 * l - q;
		r = hue2rgb(p, q, h + 1 / 3);
		g = hue2rgb(p, q, h);
		b = hue2rgb(p, q, h - 1 / 3);
	}
	return [Math.floor(r * 255), Math.floor(g * 255), Math.floor(b * 255)];
}
function hue2rgb(p, q, t) {
	if (t < 0) t += 1;
	if (t > 1) t -= 1;
	if (t < 1 / 6) return p + (q - p) * 6 * t;
	if (t < 1 / 2) return q;
	if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
	return p;
}

function numberToColorHsl(i, min, max) {
	let ratio = i;
	if (min > 0 || max < 1) {
		if (i < min) {
			ratio = 0;
		} else if (i > max) {
			ratio = 1;
		} else {
			let range = max - min;
			ratio = (i - min) / range;
		}
	}

	const hue = (ratio * 1.2) / 3.6;
	const rgb = hslToRgb(hue, 1, 0.5);
	return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
}

function freshnessToColorHsl(hours) {
	const maxHours = 15;
	let ratio = hours / maxHours;
	if (ratio > 1) {
		ratio = 1;
	}
	ratio = 1 - ratio;
	const hue = (ratio * 1.2) / 3.6;
	const rgb = hslToRgb(hue, 1, 0.5);
	return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
}

const columnData = [
	{
		id: 'number',
		label: 'Station',
	},
	{
		id: 'currentVolume',
		label: 'Current Volume',
	},
	{
		id: 'freshnessSort',
		label: 'Freshness',
	},
	{
		id: 'previousDeliverySort',
		label: 'Previous Delivery',
	},
	{
		id: 'upcomingDeliverySort',
		label: 'Upcoming Delivery',
	},
	{
		id: 'estimateSort',
		label: 'Delivery Estimate',
	},
	{
		id: 'flagSort',
		label: 'Flags',
	},
	{
		id: 'schedule',
		label: 'Schedule',
		style: { textAlign: 'left' },
		isNotSortable: true,
	},
];

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}
			id={`scrollable-force-tabpanel-${index}`}
			aria-labelledby={`scrollable-force-tab-${index}`}
			{...other}
		>
			{value === index && <Box p={3}>{children}</Box>}
		</Typography>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

class LogisticsMonitoring extends FormComponent {
	constructor(props) {
		super(props);

		let regions = [];
		if (localStorage.getItem('monitoringSavedSettings')) {
			try {
				const savedSettings = JSON.parse(localStorage.getItem('monitoringSavedSettings'));
				if (savedSettings && savedSettings.regions) {
					regions = savedSettings.regions;
				}
			} catch (e) {
				console.error('problems fetching saved searches from local storage', e);
			}
		}

		this.state = {
			order: 'asc',
			orderBy: 'currentVolume',
			orderGm: 'asc',
			orderByGm: 'currentVolume',
			orderInactive: 'asc',
			orderByInactive: 'currentVolume',
			search: '',
			tabIndex: 0,
			isEstimateDialogOpen: false,
			stationIdForEstimate: undefined,
			tankNumberForEstimate: undefined,
			estimatesByStationTank: undefined,
			commentPopoverAnchor: undefined,
			popoverComment: '',
			regions,
		};
	}

	componentDidMount() {
		const { showErrors } = this.props;
		const {
			veederInventoryRecords,
			searchMonitoring,
			deliveries,
			searchDeliveries,
			estimateDeliveries,
		} = this.props;

		if (!veederInventoryRecords.length) {
			searchMonitoring({ onlyLatest: true });
		}

		if (!deliveries.length) {
			searchDeliveries();
		}

		estimateDeliveries({
			params: {},
			callback: (err, r) => {
				if (err) {
					return showErrors([err]);
				}
				const estimatesByStationTank = {};
				_.forEach(r, (estimate) => {
					const stationTank = `${estimate.stationId}_${estimate.tankNumber}`;
					estimatesByStationTank[stationTank] = estimate;
				});
				this.setState({ estimatesByStationTank });
			},
		});
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.regions !== this.state.regions) {
			localStorage.setItem(
				'monitoringSavedSettings',
				JSON.stringify({ regions: this.state.regions })
			);
		}
	}

	handleTabChange = (event, tabIndex) => {
		this.setState({ tabIndex });
	};

	closeEstimateDialog = () => {
		this.setState({ isEstimateDialogOpen: false });
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleRowClick = (stationId, tankNumber) => {
		this.props.history.push(`/reports/stationVolume/${stationId}/${tankNumber}`);
	};

	handleSchedule = (stationId, tankNumber, productType) => {
		this.props.history.push(
			`/logistics/stationDelivery/add/${stationId}/${tankNumber}/${productType}`
		);
	};
	handleEstimate = (stationIdForEstimate, tankNumberForEstimate) => {
		this.setState({
			stationIdForEstimate,
			tankNumberForEstimate,
			isEstimateDialogOpen: true,
		});
	};

	handleUpcoming = (stationDeliveryId) => {
		this.props.history.push(`/logistics/stationDelivery/update/${stationDeliveryId}`);
	};

	handleRequestSort = (property) => {
		const orderBy = property;
		let order = 'desc';
		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleRequestSortGm = (property) => {
		const orderByGm = property;
		let orderGm = 'desc';
		if (this.state.orderByGm === property && this.state.orderGm === 'desc') {
			orderGm = 'asc';
		}
		this.setState({ orderGm, orderByGm });
	};

	handleRequestSortInactive = (property) => {
		const orderByInactive = property;
		let orderInactive = 'desc';
		if (this.state.orderByInactive === property && this.state.orderInactive === 'desc') {
			orderInactive = 'asc';
		}
		this.setState({ orderInactive, orderByInactive });
	};

	handleCommentPopoverOpen = (event, internalNote) => {
		this.setState({
			popoverComment: internalNote,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	render() {
		const { classes, veederInventoryRecords, stationMap, authUser, deliveries } = this.props;

		const { estimatesByStationTank, tabIndex } = this.state;

		if (
			_.isEmpty(veederInventoryRecords) ||
			_.isEmpty(deliveries) ||
			!stationMap ||
			!authUser ||
			!estimatesByStationTank
		) {
			return <InitialLoading />;
		}

		const {
			order,
			orderBy,
			orderGm,
			orderByGm,
			orderInactive,
			orderByInactive,
			search,
			isEstimateDialogOpen,
			stationIdForEstimate,
			tankNumberForEstimate,
		} = this.state;

		const now = moment();
		const previousDeliveryByStationTank = {};
		const upcomingDeliveryByStationTank = {};
		_.orderBy(deliveries, 'deliveryWindowEndDateTime', 'asc').forEach((delivery) => {
			const { isCancelled, deliveryWindowEndDateTime } = delivery;

			if (isCancelled) {
				return;
			}

			//- One entry per stop (leg) that has a known station
			const endDate = moment(deliveryWindowEndDateTime);
			const byStationTank = endDate.isBefore(now)
				? previousDeliveryByStationTank
				: upcomingDeliveryByStationTank;

			getDeliveryLegs(delivery).forEach((leg) => {
				const station = stationMap[leg.stationId];
				if (!station) {
					return;
				}
				const key = `${station.stationId}_${leg.tankNumber}`;
				byStationTank[key] = delivery;
				delivery[`${key}_amount`] = leg.deliveryAmount;
			});
		});

		let regionFilter;
		if (!_.isEmpty(this.state.regions)) {
			regionFilter = _.keyBy(this.state.regions);
		}

		let nonGmRows = [];
		let gmRows = [];
		let inactiveRows = [];

		veederInventoryRecords.forEach((record) => {
			const { tankNumber, stationId, productType, communicationStatusId, lastSuccess } = record;

			if (productType !== 'e85') {
				return;
			}

			const station = stationMap[stationId] || { number: 'Missing' };
			const { number, name, tanks, region, stationIsNotActive, creditHoldStartDate } = station;
			const isCreditHold = creditHoldStartDate ? true : false;

			const tankMap = _.keyBy(tanks, 'tankNumber');
			let totalTankVolume;

			if (tankMap[tankNumber]) {
				totalTankVolume = tankMap[tankNumber].totalTankVolume;
			}

			if (isFiltered({ search, data: station, fields: ['number', 'name'] })) {
				return;
			}

			//- Crap its an error. Use lastSuccess for volume
			let currentVolume, inventoryDateTime, errors;
			if (communicationStatusId === 0) {
				({ currentVolume, inventoryDateTime } = record);
				errors = [];
			} else {
				if (lastSuccess) {
					({ currentVolume, inventoryDateTime } = lastSuccess);
				} else {
					({ currentVolume, inventoryDateTime } = record);
				}
				errors = ['Communication error with device'];
			}

			const productDisplay = valueToDisplay(productType);
			const lastInventoryMoment = moment(inventoryDateTime);
			const freshnessSort = now.diff(lastInventoryMoment);
			const freshnessDisplay = moment.duration(now.diff(lastInventoryMoment)).humanize();

			const freshnessInHours = now.diff(lastInventoryMoment, 'hours');
			const freshnessColor = freshnessToColorHsl(freshnessInHours);

			if (_.includes(STATIONS_TO_HIDE, stationId)) {
				return;
			}

			const row = {
				stationId,
				number,
				region,
				regionDisplay: _.startCase(region),
				name,
				tankNumber,
				productType,
				productAndTank: `${productDisplay} / Tank #${tankNumber}`,
				currentVolume,
				totalTankVolume,
				lastInventoryDate: lastInventoryMoment.format('M/D h:mm a'),
				freshnessSort,
				freshnessDisplay,
				freshnessColor,
				communicationStatusId,
				errors,
				rowClick: () => this.handleRowClick(stationId, tankNumber),
			};

			if (totalTankVolume) {
				row.height = _.round((currentVolume / totalTankVolume) * 100, 1) + '%';
				row.percentageFilled = row.height;
				row.bgColor = numberToColorHsl(currentVolume / totalTankVolume, 0, 1);
			} else {
				row.totalTankVolume = '?';
				row.percentageFilled = 'Missing tank size';
				row.height = '100%';
				row.bgColor = '#ffffff';
			}

			//- Get totals
			const stationTank = `${stationId}_${tankNumber}`;
			const upcomingDelivery = upcomingDeliveryByStationTank[stationTank];
			if (upcomingDelivery) {
				const amount = upcomingDelivery[`${stationTank}_amount`];
				const dateTime = formatDeliveryWindow(upcomingDelivery);
				const { statusClassName, statusDisplay } = formatStatus(upcomingDelivery.status);
				row.stationUpcomingDeliveryId = upcomingDelivery.stationDeliveryId;
				row.upcomingDelivery = (
					<div>
						<div>{dateTime}</div>
						<div>{amount} gallons</div>
						<div className={classes[statusClassName]}>{statusDisplay}</div>
					</div>
				);
				const { deliveryWindowStartDateTime } = upcomingDelivery;
				row.upcomingDeliverySort = deliveryWindowStartDateTime;
			} else {
				row.upcomingDelivery = <div style={{ color: '#999' }}>No Upcoming</div>;
				row.upcomingDeliverySort = '9999-99-99';
			}

			const previousDelivery = previousDeliveryByStationTank[stationTank];
			if (previousDelivery) {
				const amount = previousDelivery[`${stationTank}_amount`];
				const dateTime = formatDeliveryWindow(previousDelivery);
				const { statusClassName, statusDisplay } = formatStatus(previousDelivery.status);
				row.stationPreviousDeliveryId = previousDelivery.stationDeliveryId;
				row.previousDelivery = (
					<div>
						<div>{dateTime}</div>
						<div>{amount} gallons</div>
						<div className={classes[statusClassName]}>{statusDisplay}</div>
					</div>
				);
				const { deliveryWindowStartDateTime } = previousDelivery;
				row.previousDeliverySort = deliveryWindowStartDateTime;
			} else {
				row.previousDelivery = <div style={{ color: '#999' }}>No Recent</div>;
				row.previousDeliverySort = '9999-99-99';
			}

			if (estimatesByStationTank && estimatesByStationTank[stationTank] && !stationIsNotActive) {
				const estimate = estimatesByStationTank[stationTank];
				const {
					recommendedDeliveryVolume,
					recommendedStartWindow,
					recommendedEndWindow,
					estimateDrift,
					allDayWindow,
					errors,
					noWindowAvailable,
					noWindowMessage,
					projectedFitStartWindow,
				} = estimate;
				row.estimateDrift = estimateDrift;

				if (!_.isEmpty(errors)) {
					row.nextEstimate = '...';
					row.estimateSort = '9999-99-99';
				} else if (noWindowAvailable) {
					row.nextEstimate = (
						<div style={{ color: '#F44337', fontWeight: 500 }}>
							{noWindowMessage || 'No Window'}
							{projectedFitStartWindow && (
								<div style={{ color: '#FF9800', fontWeight: 400, fontSize: 12 }}>
									fits {moment(projectedFitStartWindow).format('M/D ha')}
								</div>
							)}
						</div>
					);
					//- sort to the top — these need a human right away
					row.estimateSort = '0000-00-00';
				} else {
					const dateTime = formatDeliveryWindow({
						deliveryWindowStartDateTime: recommendedStartWindow,
						deliveryWindowEndDateTime: recommendedEndWindow,
						allDayWindow,
					});

					row.nextEstimate = (
						<div>
							<div>{dateTime}</div>
							<div>{recommendedDeliveryVolume} gallons</div>
						</div>
					);
					row.estimateSort = recommendedStartWindow;
				}

				const {
					isLateWarning,
					isLateError,
					isLateMessage,
					riskOfMissingDelivery,
					riskOfMissingDeliveryMessage,
					riskOfRunOutWarning,
					riskOfRunOutError,
					riskOfRunOutMessage,
					riskOfOverfillWarning,
					riskOfOverfillError,
					riskOfOverfillMessage,
					stationId,
					tankNumber,
				} = estimate;

				//const isCreditHold = creditHoldStartDate ? true : false;

				row.flagSort = 0;
				row.flagDisplay = [
					{
						error: estimate.noWindowAvailable,
						message: estimate.noWindowMessage,
						short: 'Needs Scheduling',
					},
					{ warning: isLateWarning, error: isLateError, short: 'Is Late', message: isLateMessage },
					{
						error: riskOfMissingDelivery,
						message: riskOfMissingDeliveryMessage,
						short: 'Missing Scheduled',
					},
					{
						warning: riskOfRunOutWarning,
						error: riskOfRunOutError,
						message: riskOfRunOutMessage,
						short: 'Risk of Runout',
					},
					{
						warning: riskOfOverfillWarning,
						error: riskOfOverfillError,
						message: riskOfOverfillMessage,
						short: 'Risk of Overfill',
					},
					{
						error: isCreditHold,
						message: 'Is on credit hold',
						short: 'On Credit Hold',
					},
				].map(({ warning, error, short, message }, i) => {
					if (error) {
						row.flagSort += 20;
						return (
							<div
								key={`${stationId}_${tankNumber}_${i}_error`}
								style={{ display: 'flex', justifyContent: 'center' }}
								onMouseEnter={(event) => {
									this.handleCommentPopoverOpen(event, message);
								}}
								onMouseLeave={this.handleCommentPopoverClose}
							>
								<FlagIcon className={classes.errorFlag} />
								{short}
							</div>
						);
					} else if (warning) {
						row.flagSort += 10;
						return (
							<div
								key={`${stationId}_${tankNumber}_${i}_error`}
								style={{ display: 'flex', justifyContent: 'center' }}
								onMouseEnter={(event) => {
									this.handleCommentPopoverOpen(event, message);
								}}
								onMouseLeave={this.handleCommentPopoverClose}
							>
								<FlagIcon className={classes.warningFlag} />
								{short}
							</div>
						);
					} else {
						return null;
					}
				});
			} else {
				row.nextEstimate = '...';
				row.estimateSort = '9999-99-99';

				if (isCreditHold) {
					row.flagSort = 20;
					row.flagDisplay = [
						<div
							key={`${stationId}_${tankNumber}_credit_hold_error`}
							style={{ display: 'flex', justifyContent: 'center' }}
							onMouseEnter={(event) => {
								this.handleCommentPopoverOpen(event, 'Is on credit hold');
							}}
							onMouseLeave={this.handleCommentPopoverClose}
						>
							<FlagIcon className={classes.errorFlag} />
							On Credit Hold
						</div>,
					];
				}
			}

			if (regionFilter) {
				if (!regionFilter[row.region]) {
					return;
				}
			}

			if (stationIsNotActive) {
				inactiveRows.push(row);
			} else if (number.match(/GM/)) {
				gmRows.push(row);
			} else {
				nonGmRows.push(row);
			}
		});

		nonGmRows = sortStationTable({ rows: nonGmRows, orderBy, order });
		gmRows = sortStationTable({ rows: gmRows, orderBy: orderByGm, order: orderGm });
		inactiveRows = sortStationTable({
			rows: inactiveRows,
			orderBy: orderByInactive,
			order: orderInactive,
		});

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>Tank Monitoring</span>
								<TextField
									className={classes.formControl}
									value={this.state.search}
									onChange={(event) => this.handleSearch(event)}
									label="Type to search"
									fullWidth
								/>
							</Typography>
						</Grid>
					</Grid>

					<Paper className={classes.paper} style={{ marginBottom: 10 }}>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<FMPSectionHeader label="Filter Options" isTop={true} />
							</Grid>

							<Grid item xs={12}>
								<FMPStationRegionMultiPicker {...this.setForm(`regions`)} />
							</Grid>
						</Grid>
					</Paper>

					<AppBar position="static" color="default">
						<Tabs
							value={tabIndex}
							onChange={this.handleTabChange}
							indicatorColor="primary"
							textColor="primary"
							variant="fullWidth"
							centered
						>
							<Tab label="Non G&M Stations" icon={<TruckIcon />} />
							<Tab label="G&M Stations" icon={<EyeIcon />} />
							<Tab label="Inactive Stations" icon={<InactiveIcon />} />
						</Tabs>
					</AppBar>

					<Paper className={classes.paper}>
						<TabPanel value={tabIndex} index={0}>
							{this.renderMonitoringTable({
								rows: nonGmRows,
								order,
								orderBy,
								handleRequestSort: this.handleRequestSort,
							})}
						</TabPanel>
						<TabPanel value={tabIndex} index={1}>
							{this.renderMonitoringTable({
								rows: gmRows,
								order: orderGm,
								orderBy: orderByGm,
								handleRequestSort: this.handleRequestSortGm,
							})}
						</TabPanel>

						<TabPanel value={tabIndex} index={2}>
							{this.renderMonitoringTable({
								rows: inactiveRows,
								order: orderInactive,
								orderBy: orderByInactive,
								handleRequestSort: this.handleRequestSortInactive,
							})}
						</TabPanel>

						<Popover
							id="comment-popover"
							className={classes.popover}
							classes={{ paper: classes.popOverPaper }}
							open={!!this.state.commentPopoverAnchor}
							anchorEl={this.state.commentPopoverAnchor}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							transformOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}}
							onClose={this.state.handleCommentPopoverClose}
							disableRestoreFocus
						>
							<div className={classes.commentsContainer}>
								{!!this.state.popoverComment && <div>{this.state.popoverComment}</div>}
							</div>
						</Popover>
					</Paper>

					<DeliveryEstimateDialog
						open={isEstimateDialogOpen}
						onClose={this.closeEstimateDialog}
						stationId={stationIdForEstimate}
						tankNumber={tankNumberForEstimate}
					/>
				</Grid>
			</Grid>
		);
	}

	renderMonitoringTable = ({ order, orderBy, handleRequestSort, rows }) => {
		const { classes, authUser } = this.props;
		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		return (
			<Table stickyHeader size={'small'}>
				<EnhancedTableHead
					columnData={columnData}
					order={order}
					orderBy={orderBy}
					onRequestSort={handleRequestSort}
				/>
				<TableBody>
					{rows.map((n) => {
						return (
							<PureRecordRow
								hover
								className={n.errors.length ? classes.errorRow : classes.row}
								key={`${n.stationId}_${n.tankNumber}`}
							>
								<TableCell onClick={n.rowClick}>
									<div>
										{n.number} - {n.name}
									</div>
									<div>{n.productAndTank}</div>
									<div style={{ color: '#888' }}>Region: {n.regionDisplay}</div>
								</TableCell>
								<TableCell onClick={n.rowClick}>
									<div className={classes.tankContainer}>
										<div className={classes.tankOuter}>
											<div
												className={classes.tankInner}
												style={{
													backgroundColor: n.bgColor,
													height: n.height,
												}}
											/>
										</div>
										<div className={classes.tankInfo}>
											<div>{n.percentageFilled}</div>
											<div>
												{n.currentVolume} / {n.totalTankVolume}
											</div>
											<div>{n.lastInventoryDate}</div>
										</div>
									</div>
								</TableCell>

								<TableCell>
									<div style={{ display: 'flex', alignItems: 'center' }}>
										<div
											className={classes.freshnessColor}
											style={{
												backgroundColor: n.freshnessColor,
											}}
										/>
										{n.freshnessDisplay}
									</div>
								</TableCell>

								<TableCell>
									{n.stationPreviousDeliveryId && (
										<Button
											className={classes.rowButton}
											onClick={() => this.handleUpcoming(n.stationPreviousDeliveryId)}
										>
											{n.previousDelivery}
										</Button>
									)}
									{!n.stationPreviousDeliveryId && n.previousDelivery}
								</TableCell>

								<TableCell>
									{n.stationUpcomingDeliveryId && (
										<Button
											className={classes.rowButton}
											onClick={() => this.handleUpcoming(n.stationUpcomingDeliveryId)}
										>
											{n.upcomingDelivery}
										</Button>
									)}
									{!n.stationUpcomingDeliveryId && n.upcomingDelivery}
								</TableCell>

								<TableCell>
									<Button
										className={classes.rowButton}
										onClick={() => this.handleEstimate(n.stationId, n.tankNumber)}
									>
										{n.nextEstimate}
									</Button>
								</TableCell>

								<TableCell>{n.flagDisplay}</TableCell>

								{canMakeUpdates && (
									<TableCell style={{ whiteSpace: 'nowrap' }}>
										<Button
											className={classes.button}
											onClick={() => this.handleSchedule(n.stationId, n.tankNumber, n.productType)}
										>
											Schedule
										</Button>
									</TableCell>
								)}
							</PureRecordRow>
						);
					})}
				</TableBody>
			</Table>
		);
	};
}

LogisticsMonitoring.propTypes = {
	classes: PropTypes.object.isRequired,
	searchMonitoring: PropTypes.func.isRequired,
	veederInventoryRecords: PropTypes.array,

	estimateDeliveries: PropTypes.func,
	//estimatesByStationTank : PropTypes.object,
	searchDeliveries: PropTypes.func,
	deliveries: PropTypes.array,

	stationMap: PropTypes.object,
	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
	theme: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	LogisticsMonitoringContainer,
	DeliveriesContainer,
])(LogisticsMonitoring);
